import PercentageInput from '@/components/form/percentage-input';
import {DocumentInputField} from '@/engine';
import {useDocumentLocale} from '../../hooks/use-document-locale';
import {FieldProps} from '../../meta-field';

export const PercentageField = ({
  field,
  value,
  handleChange,
  handleBlur,
  handleFocus,
}: FieldProps<DocumentInputField>) => {
  const {_t} = useDocumentLocale();

  return (
    <PercentageInput
      data-testid={`${field.id}-control`}
      name={field.id}
      onBlur={handleBlur}
      onChange={event => handleChange(event.target?.value)}
      onFocus={handleFocus}
      placeholder={_t(field.placeholder)}
      readOnly={field.readonly}
      required={field.required}
      value={value}
    />
  );
};
